import { PFlex, PFlexItem } from '@porsche-design-system/components-react'
import React from 'react'

import styles from './starrating.module.css'

function StarIcon(props: any) {
  const { fill = 'none' } = props

  return (
    <svg viewBox='0 0 20 20' className={styles.svg} version='1.1'>
      <defs>
        <polygon
          id='path-1'
          points='2 9.36357553 8.77685045 8.25760978 12.3374065 2 15.5306245 8.25760978 22 9.36357553 17.4351156 15.2404218 18.6117986 22 12.3374065 18.3340062 6.08236905 22 6.70350904 15.2404218'
        />
        <filter x='-7.5%' y='-7.5%' width='115.0%' height='115.0%' filterUnits='objectBoundingBox' id='filter-2'>
          <feGaussianBlur stdDeviation='1' in='SourceAlpha' result='shadowBlurInner1' />
          <feOffset dx='0' dy='1' in='shadowBlurInner1' result='shadowOffsetInner1' />
          <feComposite
            in='shadowOffsetInner1'
            in2='SourceAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
            result='shadowInnerInner1'
          />
          <feColorMatrix
            values='0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0'
            type='matrix'
            in='shadowInnerInner1'
          />
        </filter>
      </defs>
      <g id='Page-1' fill='none' fillRule='evenodd'>
        <g id='Path' transform='translate(-2.000000, -2.000000)'>
          <use fill={fill} fillRule='evenodd' href='#path-1' />
          <use fill='black' fillOpacity='1' filter='url(#filter-2)' href='#path-1' />
        </g>
      </g>
    </svg>
  )
}

function RatingIcon(props: any) {
  const { index, rating } = props

  const fill = React.useMemo(() => {
    if (rating >= index) {
      return '#D5001C'
    }
    return '#EDEEEE'
  }, [rating, index])

  return (
    <div className='cursor-pointer'>
      <StarIcon fill={fill} />
    </div>
  )
}

type Props = {
  rating: number
}
const StarRating: React.FC<Props> = ({ rating }) => {
  return (
    <PFlex inline className={styles.stars}>
      <PFlexItem>
        <RatingIcon index={1} rating={rating} />
      </PFlexItem>
      <PFlexItem>
        <RatingIcon index={2} rating={rating} />
      </PFlexItem>
      <PFlexItem>
        <RatingIcon index={3} rating={rating} />
      </PFlexItem>
      <PFlexItem>
        <RatingIcon index={4} rating={rating} />
      </PFlexItem>
      <PFlexItem>
        <RatingIcon index={5} rating={rating} />
      </PFlexItem>
    </PFlex>
  )
}

export default StarRating
